const initDropDown = () => {

  const form = document.querySelector('.filter__form');
  if (!form) {
    return;
  }
  const filterInput = form.querySelector('.filter__input');
  const checkBoxArray = document.querySelectorAll('.news-filter__radio');

  const resetButton = document?.getElementById('news-list-resetButton');

  const newsListBtn = document?.getElementById('dropdown-toggle--news-list');
  const newsListExpandIcon = newsListBtn?.querySelector('img');

  const yearsListBtn = document?.getElementById('dropdown-toggle--year');
  const yearsListExpandIcon = yearsListBtn?.querySelector('img');

  const newsListContent = document.getElementById('dropdown-content--news-list');
  const yearListContent = document.getElementById('dropdown-content--year');

  const rubricTitle = document?.querySelector('.rubric-title');
  const rubricTitleExpandIcon = rubricTitle?.querySelector('img');
  const rubricContent = document?.querySelector('.rubric-content');

  const handleNewsList = () => {
    newsListContent.classList.toggle('opened');
    newsListExpandIcon.classList.toggle('opened');
  };
  const handleYearList = () => {
    yearListContent.classList.toggle('opened');
    yearsListExpandIcon.classList.toggle('opened');
  };
  const resetFilter = () => {
    filterInput.value = '';
    for (const checkbox of checkBoxArray) {
      checkbox.checked = false;
    }
  };
  const rubricList = () => {
    rubricContent.classList.toggle('opened');
    rubricTitleExpandIcon.classList.toggle('opened');
  };

  newsListBtn?.addEventListener('click', handleNewsList);
  rubricTitle?.addEventListener('click', rubricList);
  yearsListBtn?.addEventListener('click', handleYearList);
  resetButton?.addEventListener('click', resetFilter);

};

export { initDropDown };
